import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MenuController, NavController, LoadingController } from '@ionic/angular';
import { NavigationExtras } from '@angular/router';

import { Constants } from "../../models/constants";
import { EventSeriesInfo } from '../../models/event-series-info';
import { PublicEventInfo } from '../../models/public-event-info';

import { ApptService } from '../../services/appt-service';
import { RecentlyViewedEvent, EventService } from '../../services/event-service';
import { Alert } from '../../services/alert';
import { Util } from '../../services/util';
import { DeviceService } from '../../services/device-service';
import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

@Component({
  selector: 'app-events',
  templateUrl: './events.page.html',
  styleUrls: ['./events.page.scss'],
})
export class EventsPage implements OnInit {

  code: string = ''

  recentlyViewedEvents: RecentlyViewedEvent[]

  selectedTab = 0

  constructor(
    private menuCtrl: MenuController,
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private observables: ObservableService,
    private eventService: EventService,
    private alert: Alert,
    private deviceService: DeviceService,
    private changeRef: ChangeDetectorRef,
    private metaTagService: MetaTagService
  ) { }

  ngOnInit() {
    this.menuCtrl.enable(true);
    this.pullRecentEvents()

    // $(document).ready(function(){

    //   $('div.tabs .tab-link').click(function(){
    //     var tab_id = $(this).attr('data-tab');

    //     $('div.tabs .tab-link').removeClass('current');
    //     $('.tab-content').removeClass('current');

    //     $(this).addClass('current');
    //     $("#"+tab_id).addClass('current');
    //   })

    // })
  }

  ionViewWillEnter() {
    this.metaTagService.updateTitle('Offices, Weddings, Festivals')
    this.metaTagService.updateTags({
      keywords: 'corporate events, corporate haircuts, office haircuts, office massages, corporate massage',
      description: 'Shortcut organizes Haircut and Massage events for hundreds of businesses across the country.',
      facebookURL: 'https://app.getshortcut.co/events',
      facebookTitle: 'Offices, Weddings, Festivals | Shortcut',
      twitterTitle: 'Offices, Weddings, Festivals | Shortcut',
      facebookDescription: 'Shortcut organizes Haircut and Massage events for hundreds of businesses across the country.',
      twitterDescription: 'Shortcut organizes Haircut and Massage events for hundreds of businesses across the country.',
      facebookImage: 'https://app.getshortcut.co/assets/img/tradestation.jpg',
    })
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/events')
  }

  private pullRecentEvents() {
    ApptService.pullRecentlyViewedEvents((rsp: RecentlyViewedEvent[]) => {

      this.recentlyViewedEvents = rsp
      this.changeRef.detectChanges()

    }, (errMsg: string) => {
      console.error(errMsg)
    })
  }

  async joinEvent() {

    let loading = await this.loadingCtrl.create()
    loading.present()

    let code = this.code.toUpperCase()

    this.eventService.submitMobileEventCode(code, (eventSeriesArray: EventSeriesInfo[]) => {

      if (this.deviceService.isMobile) {
        this.handleMobileEventCode(code)
        return
      }

      this.handleEventSeriesArray(code, eventSeriesArray, loading)

    }, (errorMsg: string) => {
      loading.dismiss()
      this.alert.show('Invalid code', errorMsg);
    });
  }


  private handleMobileEventCode(code: string) {
    window.location.href = `https://shortcut.app.link/${code}`
  }



  private handleEventSeriesArray(code: string, eventSeriesArray: EventSeriesInfo[], loading: any) {

    if (eventSeriesArray.length === 1) {

      // Go straight to event details page.

      this.eventService.pullPublicEventInfo(eventSeriesArray[0].id, (eventInfo: PublicEventInfo) => {

        loading.dismiss()

        const eventID = eventSeriesArray[0].id
        let navigationExtras: NavigationExtras = {
          state: {
            publicEventInfo: eventInfo,
          }
        }
        this.navCtrl.navigateForward(`/event-details/${eventID}`, navigationExtras)

      }, (errorMsg: string) => {
        if (!Util.isNavigationError(errorMsg)) {
          this.alert.show('Invalid code', errorMsg);
        }
      });

    } else if (eventSeriesArray.length > 0) {

      // Go to event series page.

      loading.dismiss()

      let navigationExtras: NavigationExtras = {
        state: {
          eventSeries: eventSeriesArray
        }
      }
      this.navCtrl.navigateForward(`/event/${code}`, navigationExtras)

    } else {
      loading.dismiss()
      this.alert.show('Invalid code', 'No upcoming events, or signup is not yet available.');
    }
  }


  goToRecentlyViewedEvent(e: RecentlyViewedEvent) {
    this.navCtrl.navigateForward(`/event/${e.mobileEventCode}`)
  }

  selectTab(tab: number) {
    console.log('select tab: ' + tab)
    this.selectedTab = tab
  }



  // Helpers

  learnMore() {
    window.open('https://www.getshortcut.co/corporate-events', '_blank')
  }

  requestEvent() {
    window.open('https://www.getshortcut.co/corporate-events/new', '_blank')
  }

  getDay(t: any) {
    let timezone = {
      offset: t.timezone.offset
    }
    return Util.monthDate(t.startTime, timezone)
  }

}
